
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"annee"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mois"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFacture"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"annee"},"value":{"kind":"Variable","name":{"kind":"Name","value":"annee"}}},{"kind":"Argument","name":{"kind":"Name","value":"mois"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mois"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"num_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"num_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_annonceur_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_annonceur_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"societe_client_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"societe_client_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thematique_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"facture_de_mois"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"solde_non_regle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_du_compte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marge_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"marge_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pourcentage_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_modification_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_modification_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"flag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_facture_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id_facture_coreg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat_perf"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat_coreg"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":652}};
    doc.loc.source = {"body":"query ($annee: String, $mois: String) {\n    getFacture(annee: $annee,mois: $mois){\n        num_perf\n        num_coreg\n        id_annonceur_perf\n        id_annonceur_coreg\n        societe_client_perf\n        societe_client_coreg\n        thematique_perf\n        email_perf\n        email_coreg\n        facture_de_mois\n        solde_non_regle\n        total_du_compte\n        marge_perf\n        marge_coreg\n        pourcentage_coreg\n        date_modification_perf\n        date_modification_coreg\n        status_perf\n        status_coreg\n        flag\n        email\n        id_facture_perf\n        id_facture_coreg\n        etat_perf\n        etat_coreg\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
